<template lang="pug" src="@/extensions/shop/views/Category/Partials/ProductTransferInputField/template.pug"></template>

<script>
import ProductTransferInputField from '@/extensions/shop/views/Category/Partials/ProductTransferInputField'
export default {
    name: 'CustomerTranferInputField',
    extends: ProductTransferInputField
}
</script>
